import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetCategoryCodeApprvService from "services/Setup/Master/assetCategoryCodeApprvService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  assetCategoryCodeApprvList: {},
};

export const getAssetCategoryCodeApprvList = createAsyncThunk(
  "assetCategoryCodeApprv/getAssetCategoryCodeApprvList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await AssetCategoryCodeApprvService.getAssetCategoryCodeApprvList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const assetCategoryCodeApprv = createSlice({
  name: "assetCategoryCodeApprv",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get assetCategory code list
      .addCase(getAssetCategoryCodeApprvList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetCategoryCodeApprvList.fulfilled, (state, action) => {
        state.loading = false;
        state.assetCategoryCodeApprvList = action.payload;
      })
      .addCase(getAssetCategoryCodeApprvList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  assetCategoryCodeApprv.actions;

export default assetCategoryCodeApprv.reducer;
